import {
    css, Theme,
} from '@emotion/react'

const styles = (theme: Theme) => {
    return {
        separator: css`
            color: ${theme.palette.common.white};
            font-weight: 100;
            height: 30px;
            width: 30px;
        `,
        link: css`
            color: ${theme.palette.common.white};
            text-decoration: none;
            font-weight: ${theme.typography.fontWeightRegular};
            display: block;
            white-space: nowrap;
            cursor: pointer;
        `,
    }
}

export default styles
